import { CurecallInput } from '@honestica/curecall-ui'
import { ChangeEvent } from 'react'
import validator from 'validator'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'

type Props = { name: string; requiredMessageError?: string; isDisabled?: boolean }
const EmailField = ({ name, requiredMessageError, isDisabled }: Props) => {
  const { t } = useTranslation()
  const methods = useFormContext()
  const {
    formState: { errors },
    setError,
    setValue,
    register,
    clearErrors,
  } = methods

  const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const emailValue = event.target.value
    if (!emailValue) {
      setError(name, { message: requiredMessageError })
      return
    }

    const isEmailValid = validator.isEmail(emailValue)
    if (!isEmailValid) {
      setError('emailFormat', { type: 'custom', message: t('pages.auth.error.email-format-invalid') })
    } else {
      clearErrors('emailFormat')
    }
  }

  const handleOnFocus = () => {
    clearErrors('emailFormat')
  }

  const handleOnChangeEmail = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(name, event.target.value.trim())
    clearErrors(name)
    clearErrors('validationError')
  }

  return (
    <CurecallInput
      {...register(name, { required: requiredMessageError })}
      name={name}
      type={name}
      isRequired={!!requiredMessageError}
      isDisabled={isDisabled}
      label={t('pages.auth.input.email')}
      autoComplete="email"
      placeholder={t('pages.auth.input.email-placeholder')}
      errorMessage={
        (errors?.[name]?.message || errors?.emailFormat?.message || (errors?.validationError && ' ')) as
          | string
          | undefined
      }
      onChange={handleOnChangeEmail}
      onBlur={handleOnBlur}
      onFocus={handleOnFocus}
    />
  )
}

export default EmailField
